(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-recommended-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-recommended-products')) {
    customElements.define(
      'pdp-recommended-products',
      class PdpRecommendedProducts extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-recommendations-viewport]');
          this.previousButton = this.querySelector('[data-recommendations-previous]');
          this.nextButton = this.querySelector('[data-recommendations-next]');
          this.firstCard = this.querySelector('.tp-pdp-recs__item');

          if (!this.viewport || !this.firstCard || !this.previousButton || !this.nextButton) return;

          this.handlePrevious = () => this.scrollByCard(-1);
          this.handleNext = () => this.scrollByCard(1);
          this.updateControls = this.updateControls.bind(this);

          this.previousButton.addEventListener('click', this.handlePrevious);
          this.nextButton.addEventListener('click', this.handleNext);
          this.viewport.addEventListener('scroll', this.updateControls, { passive: true });

          this.resizeObserver = new ResizeObserver(this.updateControls);
          this.resizeObserver.observe(this.viewport);
          requestAnimationFrame(this.updateControls);
        }

        disconnectedCallback() {
          if (!this.viewport) return;

          this.previousButton?.removeEventListener('click', this.handlePrevious);
          this.nextButton?.removeEventListener('click', this.handleNext);
          this.viewport.removeEventListener('scroll', this.updateControls);
          this.resizeObserver?.disconnect();
        }

        scrollByCard(direction) {
          const track = this.querySelector('.tp-pdp-recs__track');
          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = this.firstCard.getBoundingClientRect().width + gap;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.viewport.scrollBy({
            left: distance * direction,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        }

        updateControls() {
          const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          this.previousButton.disabled = this.viewport.scrollLeft <= 1;
          this.nextButton.disabled = this.viewport.scrollLeft >= maximumScroll - 1;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tp-floating-widget-hub"] && !Shopify.designMode) return;
  try {
    (() => {
    const hub = document.querySelector("[data-tp-floating-hub]");

    if (!hub) return;

    const toggle = hub.querySelector("[data-tp-floating-hub-toggle]");
    const actions = hub.querySelectorAll("[data-tp-floating-hub-action]");
    const offerAction = hub.querySelector("[data-tp-floating-hub-action='offer']");
    const menu = hub.querySelector("[data-tp-floating-hub-menu]");
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    const positionStorageKey = "tp-floating-hub-position-v1";
    const dragThreshold = 7;
    let dragState = null;
    let suppressToggleClick = false;

    const setOpen = (isOpen) => {
      if (isOpen) updateMenuDirection();
      hub.classList.toggle("is-open", isOpen);
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    };

    const setSupportOpen = (isOpen) => {
      hub.classList.toggle("is-support-open", isOpen);
      toggle.setAttribute("aria-label", isOpen ? "Close live chat" : "Open help menu");
    };

    const readPositions = () => {
      try {
        return JSON.parse(localStorage.getItem(positionStorageKey) || "{}") || {};
      } catch (error) {
        return {};
      }
    };

    const writePosition = (side, bottom) => {
      const positions = readPositions();
      positions[mobileQuery.matches ? "mobile" : "desktop"] = { side, bottom };

      try {
        localStorage.setItem(positionStorageKey, JSON.stringify(positions));
      } catch (error) {}
    };

    const getEdgeGap = () => (mobileQuery.matches ? 8 : 12);
    const getMinimumBottom = () => (mobileQuery.matches ? 48 : 12);

    const clampBottom = (bottom) => {
      const minimum = getMinimumBottom();
      const maximum = Math.max(minimum, window.innerHeight - hub.offsetHeight - getEdgeGap());
      const value = Number(bottom);
      return Math.max(minimum, Math.min(Number.isFinite(value) ? value : minimum, maximum));
    };

    const updateMenuDirection = () => {
      const rect = hub.getBoundingClientRect();
      const menuGap = mobileQuery.matches ? 50 : 58;
      const menuHeight = menu.scrollHeight || 160;
      const spaceAbove = rect.top;
      const spaceBelow = window.innerHeight - rect.bottom;
      const openDown = spaceAbove < menuHeight + menuGap && spaceBelow > spaceAbove;
      hub.dataset.menuDirection = openDown ? "down" : "up";
    };

    const applySavedPosition = () => {
      const positions = readPositions();
      const saved = positions[mobileQuery.matches ? "mobile" : "desktop"];
      const side = saved?.side === "right" ? "right" : "left";
      const fallbackBottom = mobileQuery.matches ? 48 : 12;
      const bottom = clampBottom(saved?.bottom ?? fallbackBottom);

      hub.dataset.side = side;
      hub.style.left = "";
      hub.style.right = "";
      hub.style.top = "";
      hub.style.bottom = `${bottom}px`;
      if (hub.classList.contains("is-open")) updateMenuDirection();
    };

    const handlePointerMove = (event) => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      const distance = Math.hypot(event.clientX - dragState.startX, event.clientY - dragState.startY);
      if (!dragState.moved && distance < dragThreshold) return;

      if (!dragState.moved) {
        dragState.moved = true;
        suppressToggleClick = true;
        setOpen(false);
        hub.classList.add("is-dragging");
      }

      event.preventDefault();

      const edge = getEdgeGap();
      const minTop = edge;
      const maxLeft = Math.max(edge, window.innerWidth - hub.offsetWidth - edge);
      const maxTop = Math.max(minTop, window.innerHeight - hub.offsetHeight - getMinimumBottom());
      const left = Math.max(edge, Math.min(event.clientX - dragState.offsetX, maxLeft));
      const top = Math.max(minTop, Math.min(event.clientY - dragState.offsetY, maxTop));

      hub.style.left = `${left}px`;
      hub.style.right = "auto";
      hub.style.top = `${top}px`;
      hub.style.bottom = "auto";
    };

    const finishDrag = (event) => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      const didMove = dragState.moved;
      dragState = null;
      document.removeEventListener("pointermove", handlePointerMove);
      document.removeEventListener("pointerup", finishDrag);
      document.removeEventListener("pointercancel", finishDrag);
      hub.classList.remove("is-dragging");

      try {
        toggle.releasePointerCapture(event.pointerId);
      } catch (error) {}

      if (!didMove) return;

      const rect = hub.getBoundingClientRect();
      const edge = getEdgeGap();
      const side = rect.left + rect.width / 2 < window.innerWidth / 2 ? "left" : "right";
      const targetLeft = side === "left" ? edge : window.innerWidth - rect.width - edge;
      const bottom = clampBottom(window.innerHeight - rect.bottom);
      const targetTop = window.innerHeight - rect.height - bottom;

      hub.dataset.side = side;
      hub.classList.add("is-snapping");
      hub.style.right = "auto";
      hub.style.left = `${targetLeft}px`;
      hub.style.top = `${targetTop}px`;
      hub.style.bottom = "auto";
      writePosition(side, bottom);

      window.setTimeout(() => {
        hub.style.left = "";
        hub.style.right = "";
        hub.style.top = "";
        hub.style.bottom = `${bottom}px`;
        hub.classList.remove("is-snapping");
        updateMenuDirection();
      }, 230);

      window.setTimeout(() => {
        suppressToggleClick = false;
      }, 0);
    };

    toggle.addEventListener("pointerdown", (event) => {
      if (event.button != null && event.button !== 0) return;

      const rect = hub.getBoundingClientRect();
      dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        offsetX: event.clientX - rect.left,
        offsetY: event.clientY - rect.top,
        moved: false,
      };

      document.addEventListener("pointermove", handlePointerMove, { passive: false });
      document.addEventListener("pointerup", finishDrag);
      document.addEventListener("pointercancel", finishDrag);

      try {
        toggle.setPointerCapture(event.pointerId);
      } catch (error) {}
    });

    const waitFor = (test, callback, attempts = 20) => {
      if (test()) {
        callback();
        return;
      }

      if (attempts <= 0) return;

      window.setTimeout(() => waitFor(test, callback, attempts - 1), 300);
    };

    const hideZendeskLauncher = () => {
      if (typeof window.zE !== "function") return;

      try {
        window.zE("messenger", "hide");
      } catch (error) {
        try {
          window.zE("webWidget", "hide");
        } catch (classicError) {}
      }
    };

    const openZendesk = () => {
      const open = () => {
        if (typeof window.zE !== "function") return false;

        try {
          window.zE("messenger", "show");
          window.zE("messenger", "open");
          setSupportOpen(true);
          return true;
        } catch (error) {
          try {
            window.zE("webWidget", "show");
            window.zE("webWidget", "open");
            setSupportOpen(true);
            return true;
          } catch (classicError) {
            return false;
          }
        }
      };

      if (!open()) {
        waitFor(() => typeof window.zE === "function", open);
      }
    };

    const closeZendesk = () => {
      if (typeof window.zE !== "function") {
        setSupportOpen(false);
        return;
      }

      try {
        window.zE("messenger", "close");
        window.zE("messenger", "hide");
      } catch (error) {
        try {
          window.zE("webWidget", "close");
          window.zE("webWidget", "hide");
        } catch (classicError) {}
      }

      setSupportOpen(false);
    };

    const openSmile = () => {
      if (window.SmileUI && typeof window.SmileUI.openPanel === "function") {
        window.SmileUI.openPanel();
        return;
      }

      window.location.hash = "smile-home";

      waitFor(
        () => window.SmileUI && typeof window.SmileUI.openPanel === "function",
        () => {
          window.SmileUI.openPanel();
        },
        40
      );
    };

    const getSubscriptionPopup = () => document.querySelector("subscription-popup");

    const syncSubscriptionOffer = () => {
      const popup = getSubscriptionPopup();
      const shouldHide = !popup;

      if (offerAction.hidden !== shouldHide) offerAction.hidden = shouldHide;
    };

    const openSubscriptionPopup = () => {
      const open = () => {
        const popup = getSubscriptionPopup();
        if (!popup || typeof popup.show !== "function") return false;

        popup.show();
        return true;
      };

      if (!open()) {
        waitFor(() => typeof getSubscriptionPopup()?.show === "function", open);
      }
    };

    const hideSmileLaunchers = () => {
      const selectors = [
        "[data-smile-launcher]",
        ".smile-launcher",
        "[class*='smile-launcher']",
        "[id*='smile-launcher']",
        "[class*='smile-ui-lite-launcher']",
        "[id*='smile-ui-lite-launcher']",
        "iframe[title*='Smile' i][title*='launcher' i]",
        "iframe[aria-label*='Smile' i][aria-label*='launcher' i]",
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => {
          if (hub.contains(element)) return;

          element.style.setProperty("opacity", "0", "important");
          element.style.setProperty("pointer-events", "none", "important");
          element.style.setProperty("transform", "scale(0.01)", "important");
          element.setAttribute("aria-hidden", "true");
        });
      });
    };

    const hideLegacyPointsButton = () => {
      document.querySelectorAll("button, a, div[role='button']").forEach((element) => {
        if (hub.contains(element)) return;
        if (element.textContent.trim() !== "Points") return;

        const rect = element.getBoundingClientRect();
        const isSmallFloating =
          rect.width > 32 &&
          rect.width < 160 &&
          rect.height > 24 &&
          rect.height < 88 &&
          rect.left < 140 &&
          rect.bottom > window.innerHeight - 180;

        if (!isSmallFloating) return;

        element.style.setProperty("opacity", "0", "important");
        element.style.setProperty("pointer-events", "none", "important");
        element.style.setProperty("transform", "scale(0.01)", "important");
        element.setAttribute("aria-hidden", "true");
      });
    };

    document.body.classList.add("tp-floating-hub-ready");
    requestAnimationFrame(applySavedPosition);
    waitFor(() => typeof window.zE === "function", hideZendeskLauncher);
    syncSubscriptionOffer();
    hideSmileLaunchers();

    let hideLaunchersTimer = 0;
    const scheduleHideLaunchers = () => {
      if (hideLaunchersTimer) return;
      hideLaunchersTimer = window.setTimeout(() => {
        hideLaunchersTimer = 0;
        hideSmileLaunchers();
      }, 300);
    };

    let pointsScans = 0;
    const pointsScanTimer = window.setInterval(() => {
      hideLegacyPointsButton();
      pointsScans += 1;
      if (pointsScans >= 4) window.clearInterval(pointsScanTimer);
    }, 1500);

    new MutationObserver(() => {
      syncSubscriptionOffer();
      scheduleHideLaunchers();
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });

    toggle.addEventListener("click", (event) => {
      if (suppressToggleClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressToggleClick = false;
        return;
      }

      if (hub.classList.contains("is-support-open")) {
        closeZendesk();
        setOpen(false);
        return;
      }

      setOpen(!hub.classList.contains("is-open"));
    });

    const handleViewportChange = () => applySavedPosition();
    window.addEventListener("resize", handleViewportChange);
    if (window.visualViewport) window.visualViewport.addEventListener("resize", handleViewportChange);
    if (mobileQuery.addEventListener) mobileQuery.addEventListener("change", handleViewportChange);

    actions.forEach((action) => {
      action.addEventListener("click", () => {
        setOpen(false);

        if (action.dataset.tpFloatingHubAction === "offer") {
          openSubscriptionPopup();
          return;
        }

        if (action.dataset.tpFloatingHubAction === "support") {
          if (window.TPSpeedDefer && typeof window.TPSpeedDefer.flushMatching === "function") {
            window.TPSpeedDefer.flushMatching(/zdassets|zendesk/i);
          }
          if (window.TPSpeedDefer && typeof window.TPSpeedDefer.flush === "function") {
            window.TPSpeedDefer.flush();
          }
          openZendesk();
          return;
        }

        if (action.dataset.tpFloatingHubAction === "points") {
          openSmile();
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (!hub.contains(event.target)) {
        setOpen(false);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        closeZendesk();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tp-variant-certification-numbers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tp-variant-certification-numbers')) {
    customElements.define('tp-variant-certification-numbers', class extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-variant-certification-data]');
        if (!data) return;

        try {
          this.numbersByVariant = JSON.parse(data.textContent);
        } catch (error) {
          return;
        }

        this.productInfo = this.closest('product-info');
        this.onVariantInputChange = (event) => {
          const input = event.target;
          if (!input.matches('input[name="id"]')) return;
          const formId = input.form?.getAttribute('id');
          const expectedId = this.getAttribute('form-id');
          if (formId !== expectedId && formId !== expectedId.replace('product-form-', 'product-form-installment-')) return;
          this.updateNumbers(input.value);
        };
        this.productInfo?.addEventListener('change', this.onVariantInputChange);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onVariantInputChange);
      }

      updateNumbers(variantId) {
        const numbers = this.numbersByVariant[String(variantId)] || {};
        let hasNumber = false;

        for (const type of ['halal', 'bpom']) {
          const row = this.querySelector(`[data-certification-row="${type}"]`);
          const value = row.querySelector(`[data-certification-value="${type}"]`);
          const number = numbers[type] == null ? '' : String(numbers[type]).trim();

          value.textContent = number;
          row.hidden = number === '';
          if (number !== '') hasNumber = true;
        }

        this.hidden = !hasNumber;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
